import moment from 'moment';

import { WithTimestamp } from 'packages/kakapo-ui-services/types/WithTimestamp';

export interface IWithId {
	id: string;
}

export enum ListServiceDateFormat {
	Month = 'YYYY-MM',
	Week = 'YYYY-W',
}

class ListService {
	static reorder<T>(list: Array<T>, startIndex: number, endIndex: number): Array<T> {
		const result = Array.from(list);
		const [removed] = result.splice(startIndex, 1);
		result.splice(endIndex, 0, removed);

		return result;
	}

	static sortDesc(list: Array<string>) {
		return list.sort((a, b) => parseInt(b, 10) - parseInt(a, 10));
	}

	static sortAsc(list: Array<string>) {
		return list.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
	}

	static reduceListToYear = <T extends WithTimestamp>(list: Array<T>) => {
		const elementsByKeyRecord: Record<string, Array<T>> = {};

		return list.reduce((result, element) => {
			const { timestamp } = element;
			const key = String(timestamp.getFullYear());

			if (result[key] != null) {
				return {
					...result,
					[key]: result[key].concat([element]),
				};
			}

			return {
				...result,
				[key]: [element],
			};
		}, elementsByKeyRecord);
	};

	static reduceListToDateFormat = <T extends WithTimestamp>(
		list: Array<T>,
		format: ListServiceDateFormat,
	) => {
		const elementsByKeyRecord: Record<string, Array<T>> = {};

		return list.reduce((result, element) => {
			const { timestamp } = element;
			const key = moment(timestamp).format(format as string);

			if (result[key] != null) {
				return {
					...result,
					[key]: result[key].concat([element]),
				};
			}

			return {
				...result,
				[key]: [element],
			};
		}, elementsByKeyRecord);
	};

	static replaceElementWithId = <T extends IWithId>(
		list: Array<T>,
		replaceElement: T,
	): Array<T> => {
		return list.map((element) => {
			if (element.id === replaceElement.id) {
				return replaceElement;
			}
			return element;
		});
	};

	static getListWithoutElementWithId = <T extends IWithId>(
		list: Array<T>,
		removeElement: T,
	): Array<T> => {
		return list.filter((element) => element.id !== removeElement.id);
	};
}

export default ListService;
